import React from 'react';
import { DataElement, DefaultDataElement } from '../charts/types';

export interface SlidesProps {
    data: DataElement;
    reset: () => void;
    moveNext: () => void;
    ready: boolean;
}

export function Slides(props: SlidesProps) {
    const image = props.data.IMAGE ? require('../images/' + props.data.IMAGE) : '';
    let {
        CPU,
        YEAR,
        MIPS,
        TDP,
        CORES_DIE,
        BLURB
    } = props.data;
    
    if (YEAR === DefaultDataElement.YEAR && MIPS === DefaultDataElement.MIPS) {
        YEAR = '';
        CPU = 'Loading...';
    }

    return (
        <div className='control-panel'>
            <div className='row justify-content-center'>
                <button
                    type='button'
                    className='btn btn-primary'
                    onClick={props.moveNext}
                    disabled={!props.ready}
                >
                        Next Year
                </button>
                <button
                    type='button'
                    className='btn btn-warning'
                    onClick={props.reset}
                    disabled={!props.ready}
                >
                        Reset
                </button>
            </div>

            <div className='row justify-content-center'>
                <div className='card' style={{width: '24rem'}}>
                    <div className='card-body'>
                            {image ? 
                                <div className='card-img-container'>
                                    <img className="card-img-top" src={image} alt={CPU} /> 
                                </div>
                            : null}
                        <h4 className='card-title'>{CPU}</h4>
                        <h5 className='card-subtitle mb2 text-muted'>
                            {YEAR}
                        </h5>
                        <h6 className='card-subtitle mb2 text-muted'>
                            {parseFloat(MIPS)} MIPS,{' '}
                            {parseFloat(TDP || '0')} Watt TDP,{' '} 
                            {
                                CORES_DIE === '1' 
                                    ? 'Single Core' 
                                    : CORES_DIE + ' Cores'
                            }
                        </h6>
                        <p className='card-text'>{BLURB}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}